import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { removeToCart, decreseQuantity, increseQuantity, handleClear, getTotal } from '../features/counter/counterSlice'
import { useNavigate } from 'react-router-dom'

function Cart() {

  const item = useSelector((state) => state.counter)

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getTotal())
  }, [item, dispatch])

  const handleRemoveCart = (data) => {
    dispatch(removeToCart(data))
  }

  const handleDecreeQuantity = (data) => {
    dispatch(decreseQuantity(data))
  }
  const handleincreseQuantity = (data) => {
    dispatch(increseQuantity(data))
  }
  const handleClearAllCart = () => {
    dispatch(handleClear())
  }


  return (
    <div>

      <section className="h-100 gradient-custom">
        <div className="container py-5">
          <div className="row d-flex justify-content-center my-4">
            <div className="col-md-8">
              <div className="card mb-4">
                <div className="card-header py-3">
                  <h5 className="mb-0">Cart - {item.cartTotalQuantity} items</h5>
                </div>
                <div className="card-body">
                  <div className="row">

                    {

                      item.cartItem.map(data => (
                        <>

                          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
                            <div className="bg-image hover-overlay hover-zoom ripple rounded" data-mdb-ripple-color="light">
                              <img src={data.image}
                                className="w-100" alt="Blue Jeans Jacket" />
                              <a href="#!">
                                <div className="mask" style={{ "background-color": "rgba(251, 251, 251, 0.2)" }}></div>
                              </a>
                            </div>
                          </div>



                          <div className="col-lg-5 col-md-6 mb-4 mb-lg-0">
                            <p><strong>{data.title}</strong></p>
                            <p>Color: red</p>
                            <p>Size: M</p>

                            <button type="button" className="btn btn-danger btn-sm me-1 mb-2" data-mdb-toggle="tooltip"
                              title="Remove item" onClick={() => handleRemoveCart(data)}>
                              <i className="fas fa-trash"></i>
                            </button>

                          </div>

                          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                            <div className="d-flex mb-4" style={{ "max-width": "300px" }}>

                              <button className="btn btn-secondary px-3 me-2"
                                onClick={() => { handleDecreeQuantity(data) }}>
                                <i className="fas fa-minus"></i>
                              </button>

                              <div className="form-outline">
                                <p className="text-center text-bold" >{data.quantity}</p>
                                <label className="form-label" for="form1">Quantity</label>
                              </div>

                              <button className="btn btn-secondary px-3 ms-2"
                                onClick={() => { handleincreseQuantity(data) }}>
                                <i className="fas fa-plus"></i>
                              </button>
                            </div>

                            <p className="text-start text-md-center">
                              <strong> ${data.price}</strong>
                            </p>
                          </div>
                            <hr />
                        </>

                      ))
                    }
                  </div>
                </div>
              </div>
        </div>
             
            <div className="col-md-4">
              <button type="button" className="btn btn-danger btn-sm mb-2" data-mdb-toggle="tooltip"
                title="clear Cart" onClick={() => handleClearAllCart()}>
                ClearCart
              </button>
              <div className="card mb-4">
                <div className="card-header py-3">
                  <h5 className="mb-0">Summary</h5>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li
                      className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                      Products
                      <span>$53.98</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                      Shipping
                      <span>Gratis</span>
                    </li>
                    <li
                      className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                      <div>
                        <strong>Total amount</strong>
                        <strong>
                          <p className="mb-0">(including VAT)</p>
                        </strong>
                      </div>
                      <span><strong>$ {item.cartTotalAmount}</strong></span>
                    </li>
                  </ul>

                  <button type="button" className="btn btn-secondary btn-lg btn-block"  onClick={() =>{navigate('/products')}}>
                    Go to checkout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default Cart